import { supabase } from './supabase/supabaseClient.js';

// Listar todas las polizas colectivas
export const getPolizas = async () => {
  const { data, error } = await supabase
    .from('polizas_colectivas')
    .select(`
      *,
      plan:planes(nombre),
      compania:companias(nombre_corto),
      ramo:ramos(nombre)
    `)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
};

// Listar polizas colectivas por ids (para resolver vinculaciones de
// empresa_planes_habilitados.poliza_colectiva_id en batch, sin N+1).
export const getPolizasByIds = async (ids) => {
  if (!ids || ids.length === 0) return [];
  const { data, error } = await supabase
    .from('polizas_colectivas')
    .select('id, numero_poliza, estado, compania:companias(nombre_corto)')
    .in('id', ids);
  if (error) throw error;
  return data || [];
};

// Listar polizas colectivas por plan
export const getPolizasByPlanId = async (planId) => {
  const { data, error } = await supabase
    .from('polizas_colectivas')
    .select('*')
    .eq('plan_id', planId)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
};

// Obtener una poliza por ID
export const getPolizaById = async (id) => {
  const { data, error } = await supabase
    .from('polizas_colectivas')
    .select(`
      *,
      plan:planes(id, nombre, producto_id),
      plan_company:company_planes(id),
      compania:companias(id, nombre_corto),
      contratante:contratantes_colectivos(id, nombre_razon_social)
    `)
    .eq('id', id)
    .single();
  if (error) throw error;
  return data;
};

// Crear poliza colectiva
export const createPoliza = async (polizaData) => {
  const payload = {
    plan_id: polizaData.plan_id,
    compania_id: polizaData.compania_id,
    ramo_id: polizaData.ramo_id || null,
    numero_poliza: polizaData.numero_poliza || null,
    numero_contrato: polizaData.numero_contrato || null,
    url_poliza: polizaData.url_poliza || null,
    fecha_emision: polizaData.fecha_emision || null,
    fecha_inicio: polizaData.fecha_inicio || null,
    fecha_termino: polizaData.fecha_termino || null,
    estado: polizaData.estado || 'vigente',
    contratante_id: polizaData.contratante_id || null,
    metadata: polizaData.metadata || null,
    prima_total: polizaData.prima_total !== undefined && polizaData.prima_total !== null ? parseFloat(polizaData.prima_total) : null,
    moneda: polizaData.moneda || null,
    wallet_back_config: polizaData.wallet_back_config ?? null,
  };
  const { data, error } = await supabase
    .from('polizas_colectivas')
    .insert([payload])
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Actualizar poliza colectiva
export const updatePoliza = async (id, polizaData) => {
  const payload = {
    plan_id: polizaData.plan_id,
    compania_id: polizaData.compania_id,
    ramo_id: polizaData.ramo_id || null,
    numero_poliza: polizaData.numero_poliza || null,
    numero_contrato: polizaData.numero_contrato || null,
    url_poliza: polizaData.url_poliza || null,
    fecha_emision: polizaData.fecha_emision || null,
    fecha_inicio: polizaData.fecha_inicio || null,
    fecha_termino: polizaData.fecha_termino || null,
    estado: polizaData.estado || 'vigente',
    contratante_id: polizaData.contratante_id || null,
    metadata: polizaData.metadata || null,
    prima_total: polizaData.prima_total !== undefined && polizaData.prima_total !== null ? parseFloat(polizaData.prima_total) : null,
    moneda: polizaData.moneda || null,
    wallet_back_config: polizaData.wallet_back_config ?? null,
    updated_at: new Date().toISOString()
  };
  const { data, error } = await supabase
    .from('polizas_colectivas')
    .update(payload)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Eliminar poliza colectiva
export const deletePoliza = async (id) => {
  const { error } = await supabase
    .from('polizas_colectivas')
    .delete()
    .eq('id', id);
  if (error) throw error;
  return true;
};